import { Route,Routes } from "react-router-dom";
import './App.css';
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Home from "./components/Home";
import Navbar from "./components/Navbar";
import Notfound from "./components/Notfound";
import Services from "./components/Services";

function App() {
  return (
    <div className="">
      <Navbar  />
      <Routes>
<Route   path="/"  element={ <Home  />} />
<Route   path="/about"  element={<About  />} />
<Route   path="/contact"  element={<Contact  />} />
<Route   path="/service"  element={ <Services />} />
<Route   path="*"  element={ <Notfound />} />
      </Routes>
    
     <Footer />
    
    </div>
  );
}

export default App;
